export default __webpack_public_path__ + "static/media/k8s-logo.e7aa0c8a.svg";